import {ReportLineDetailData} from '../../interfaces/report-line-details.interface';
import {InquiryOrder} from '../../features/inquiry/data-access/interface/inquiry.interface';

export function mapReportLineDetailsToInquiryOrder(reportLine: ReportLineDetailData): InquiryOrder {
  return {
    orderId: reportLine.salesDocNumber,
    orderItemPosition: reportLine.position,
    poNumber: reportLine.poNumber,
    shipTo: reportLine.shipTo,
    soldTo: reportLine.soldTo,
    productCode: reportLine.productCode,
    productName: reportLine.productName,
  };
}
